export default __webpack_public_path__ + "partner_1fe8127.png";